import { useCallback, useRef } from 'react';
import { getNewSingleInstrumentationID } from '../effects/getNewSingleInstrumentationID';
import { readSingleInstrumentationIDCookie, setSingleInstrumentationIDCookie } from '../effects/singleInstrumentationIDCookieManagement';
import { AISessionState } from '../events';
export var useAIInstrumentationSetup = function useAIInstrumentationSetup(customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig) {
  var singleInstrumentationIDRef = useRef(undefined);
  var aiSessionStateRef = useRef(AISessionState.unset);
  var setAISessionState = useCallback(function (nextState) {
    aiSessionStateRef.current = nextState;
  }, []);
  var getAISessionState = useCallback(function () {
    return aiSessionStateRef.current;
  }, []);
  var refreshSingleInstrumentationID = useCallback(function (customSingleInstrumentationIDFromEvent) {
    var nextSingleInstrumentationID = getNewSingleInstrumentationID(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
    singleInstrumentationIDRef.current = nextSingleInstrumentationID;
    if (cookieSingleInstrumentationConfig) {
      void setSingleInstrumentationIDCookie(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }
  }, [customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig]);
  var getSingleInstrumentationID = useCallback(function () {
    // this handles a race condition when we have a new singleInstrumentationID from the user config
    // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
    // singleInstrumentationID at first step and then return a new one.
    if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
      refreshSingleInstrumentationID();
      return singleInstrumentationIDRef.current;
    }
    if (cookieSingleInstrumentationConfig) {
      return readSingleInstrumentationIDCookie(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
    }
    return singleInstrumentationIDRef.current;
  }, [customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig, refreshSingleInstrumentationID]);
  return {
    refreshSingleInstrumentationID: refreshSingleInstrumentationID,
    getSingleInstrumentationID: getSingleInstrumentationID,
    setAISessionState: setAISessionState,
    getAISessionState: getAISessionState
  };
};